import styled from 'styled-components';

export const Content = styled.div`
  & .workspaceSettings-inputWrapper {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    position: relative;
    label {
      font-weight: 500;
      font-size: 12px;
      line-height: 100%;
      color: var(--color-text-muted);
      margin: -10px 0 10px;
      display: block;
    }
  }

  .inputContainer {
    padding: 0 0 20px;
  }

  input {
    height: 40px;
  }

  .workspaceSettings-errorMessage {
    color: #ff2f2f;
    margin-top: -20px;
    font-weight: 500;
    font-size: 10px;
    line-height: 100%;
  }

  .workspaceSettings-infoMessage {
    color: var(--color-text-muted);
    text-align: center;
  }

  .buttonContainer {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin: 20px auto 0;
    button {
      width: 130px;
    }
  }

  .largeText {
    text-align: center;
    margin-top: 0;
    font-size: 16px;
    font-weight: 300;
  }

  & .switcher {
    display: flex;
    margin-bottom: 20px;
  }

  .roleEdit {
    display: flex;
  }
`;
